import dynamic from "next/dynamic";
import Image from "next/image";
import BlogCardTechLts from "../../components/blog/BlogCardTechLts";
import BlogCardTechFeatured from "../../components/blog/BlogCardTechFeatured";
import styles from "../../styles/Tech.module.css";
import blogData from "../../blogs.json";

const Navbar = dynamic(() => import("../../components/Navbar"), {
  ssr: false,
});
const Footer = dynamic(() => import("../../components/Footer"));

TechTales.title = "Tech Tales";
TechTales.desc = "Itmtb's technology blogs";
TechTales.header_img = "https://www.itmtb.com/blog/grid/techTalesBg.webp";
TechTales.pathname = process.env.NEXT_PUBLIC_WEBSITE + "tech-tales";
TechTales.keywords = "tech, technology, design, coding, programming, react, next js, itmtb, technologies.";

export async function getStaticProps() {
  const filterTech = blogData.map(item => {
    if (item?.meta.category === "tech") {
      return {
        title: item.meta.title,
        img: item.meta.img,
        slug: item.meta.slug,
        date: item.meta.date,
        time: item.meta.time_to_read,
        subtitle: item.meta.subtitle,
      };
    }
  });

  const sortedData = [...filterTech].filter(item => !!item);

  return {
    props: { sortedData },
  };
}

export default function TechTales({ sortedData }) {
  return (
    <div className=" blog min-h-screen bg-white">
      <Navbar />
      <div className={`relative z-10 ${styles.tech_hero_container}`}>
        <div className={`relative z-10 ${styles.tech_hero}`}>
          <Image
            src="/blog/grid/techTalesBg.webp"
            alt="tech-tales"
            width="1200"
            height="660"
            layout="fill"
            priority={true}
            sizes="(max-width: 500px) 50vw,
              (max-width: 1200px) 70vw,
              100vw"
          />
          <div className={`absolute z-20 ${styles.tech_hero_text}`}>
            <h1>TECH TALES</h1>
            <hr />
            <h2>Dive Into The Infinite Realm Of Technology</h2>
          </div>
        </div>

        <div className={styles.tech_latest}>
          <h4>Latest Blogs -</h4>
          <hr />
          <div className={styles.tech_latest_blogs}>
            {sortedData.slice(0, 2).map(post => (
              <BlogCardTechLts
                key={post.slug}
                title={post.title}
                src={post.img}
                alt={post.slug}
                date={post.date}
                time={post.time}
                slug={post.slug}
                desc={post.subtitle}
              />
            ))}
          </div>
        </div>
      </div>

      <div className={styles.tech_featured}>
        <h4>Featured Blogs -</h4>
        <hr />
        <div className="flex flex-wrap">
          {sortedData.slice(2).map(post => (
            <BlogCardTechFeatured key={post.slug} title={post.title} img={post.img} alt={post.slug} slug={post.slug} date={post.date} desc={post.subtitle} />
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
}

// export default TechTales;
